import { useEffect } from 'react';
import {
  useFeaturedContentQuery,
  useStreamConfigQuery,
  shouldLogQueryError,
} from '../hooks/queries/useCoreCatalogQueries';
import { actionTypes } from '../contexts/AppContext';

/**
 * Hydrates AppContext stream config + featured content from TanStack Query cache.
 * Replaces ad-hoc fetches in app init (Sprint B — first Query rollout).
 */
export function CoreCatalogQuerySync({ dispatch }) {
  const stream = useStreamConfigQuery();
  const featured = useFeaturedContentQuery();

  useEffect(() => {
    if (stream.data) {
      dispatch({ type: actionTypes.SET_STREAM_CONFIG, payload: stream.data });
    }
  }, [stream.data, dispatch]);

  useEffect(() => {
    if (featured.data) {
      dispatch({ type: actionTypes.SET_FEATURED_CONTENT, payload: featured.data });
    }
  }, [featured.data, dispatch]);

  useEffect(() => {
    if (stream.error && shouldLogQueryError(stream.error)) {
      console.error('Failed to load stream config:', stream.error);
    }
  }, [stream.error]);

  useEffect(() => {
    if (featured.error && shouldLogQueryError(featured.error)) {
      console.error('Failed to load featured content:', featured.error);
    }
  }, [featured.error]);

  return null;
}
